import { render, staticRenderFns } from "./ReplenishmentDropdownTable.vue?vue&type=template&id=16036722&scoped=true&"
import script from "./ReplenishmentDropdownTable.vue?vue&type=script&lang=js&"
export * from "./ReplenishmentDropdownTable.vue?vue&type=script&lang=js&"
import style0 from "./ReplenishmentDropdownTable.vue?vue&type=style&index=0&id=16036722&prod&lang=css&"
import style1 from "./ReplenishmentDropdownTable.vue?vue&type=style&index=1&id=16036722&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16036722",
  null
  
)

export default component.exports